import React, { useState, useEffect } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Ballot } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { wsFindBy } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';

import { Tooltip } from '@material-ui/core';
import { useModal } from 'hooks/useModal';
import OrderTransactionModal from 'components/Tvendo/Order/OrderTransactionModal';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Fecha', accessor: 'start_date', width: 200 },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Vendedor', accessor: 'SlpName', width: 350 },
  { Header: 'Canal', accessor: 'base_canal_description', width: 150 },
  { Header: 'Fuerza venta', accessor: 'base_sale_force_id', width: 150 },
  { Header: 'Razón no pedido', accessor: 'base_reason_description_not_order', width: 150 },
  { Header: 'Motivo no pedido', accessor: 'reason_description', width: 150 },
  { Header: 'Cód. movil', accessor: 'movil_uuid', width: 300 },
  { Header: 'Comentario', accessor: 'comment', width: 300 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function NoOrder(props) {
  const classes = useStyles();
  const bPartner = props.businessPartner;

  const [noOrders, setNoOrders] = useState([]);
  const [logModel, setLogModalOpen] = useModal();

  async function listNoOrder() {
    // is_order = N: el ws devuelve solo los no pedidos (sin razón de prioridad)
    let response = await wsFindBy('ordm/order', {
      base_business_partner_id: bPartner.id,
      is_order: 'N'
    });
    if (response.success) setNoOrders(response.data);
  }

  useEffect(() => {
    listNoOrder();
  }, []);

  return (
    <>
      <OrderTransactionModal model={logModel} setOpen={setLogModalOpen} entity="ordm/order" />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de No Pedidos</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            formatDate="YYYY-MM-DD"
            excelName={'No-pedidos-de-socio-' + bPartner.CardCode}
            defaultWidth={2400}
            columns={columns}
            data={noOrders.map((noOrder, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Tooltip title="Logs">
                      <Button
                        justIcon
                        round
                        simple
                        color="warning"
                        onClick={() => {
                          setLogModalOpen(noOrder);
                        }}
                      >
                        <Ballot />
                      </Button>
                    </Tooltip>
                  </div>
                ),
                id: noOrder.id.toString(),
                start_date: noOrder.start_date,
                Address2: noOrder.Address2,
                SlpName: noOrder.SlpName,
                base_canal_description: noOrder.base_canal_description,
                base_sale_force_id: noOrder.base_sale_force_id,
                base_reason_description_not_order: noOrder.base_reason_description_not_order,
                reason_description: noOrder.reason_description,
                movil_uuid: noOrder.movil_uuid,
                comment: noOrder.comment,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
